import { Context } from '@nuxt/types/app'

export default function (context: Context) {
  if (!process.client) return

  if (!context.$analytics) return

  context.$analytics.page()
}
